var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-panel__filter-result" }, [
    _vm.windowWidth < 960
      ? _c("div", { staticClass: "grid__container" }, [
          _c(
            "a",
            {
              class: [
                "search-panel__result-button",
                { "is-disabled": _vm.link.disabled }
              ],
              attrs: { href: _vm.link.href }
            },
            [
              !_vm.link.disabled
                ? _c("span", [
                    _vm._v("\n                Смотреть "),
                    _c("span", { staticClass: "link__no-br" }, [
                      _vm._v(_vm._s(_vm.link.text))
                    ])
                  ])
                : _c("span", [_vm._v(_vm._s(_vm.link.text))])
            ]
          )
        ])
      : _c(
          "a",
          {
            class: [
              "link",
              "link_theme_white",
              { "is-disabled": _vm.link.disabled }
            ],
            attrs: { href: _vm.link.href }
          },
          [
            !_vm.link.disabled
              ? _c("span", { staticClass: "link__inner" }, [
                  _c("span", { staticClass: "search-panel__result-word" }, [
                    _vm._v("Смотреть ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "link__no-br" }, [
                    _vm._v(_vm._s(_vm.link.text))
                  ])
                ])
              : _c("span", { staticClass: "link__inner" }, [
                  _vm._v(_vm._s(_vm.link.text))
                ]),
            _vm._v(" "),
            _c("LinkIconArrow")
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }